import React from 'react';
import './index.scss';
import HeaderIconUser from 'eco-design/section-layout/ef-nav-common/UserV1/IconUser';
import LocaleIcon from 'eco-design/section-layout/ef-nav-common/GlobalLocaleV1/LocaleIcon';
import getLocal from 'eco-design-reliance/getLocal';
import { BhHeaderV2Lang } from 'eco-design/section-layout/ef-header-v2/BhHeaderV2Lang';
import EcoLink from 'eco-design/base/eco-link';
import { getIsLogin } from 'eco-design-micro/utils-user/web/webToken';
import { useEffect, useState } from 'react';
import { HideUserLocaleList } from 'eco-design/section-layout/ef-nav-common/UserV1';
import gtm from 'eco-design-reliance/gtm';

const H5BottomTabs: React.FC = ({}) => {
    const { locale = 'us', pathname } = getLocal();
    const t = BhHeaderV2Lang[locale] || BhHeaderV2Lang['en'];

    const [isLogin, setIsLogin] = useState(false);
    useEffect(() => {
        const isLogin2 = getIsLogin();
        setIsLogin(isLogin2);
    }, []);

    const enterUserHandle = () => {
        if (!isLogin) {
            location.href = `/${locale}/login?redirect=${encodeURIComponent(location.href)}`;
            return;
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'top_function',
            button_name: 'Brand_My Account_Logged in',
            __btn_id1: `ef-header-user-h5`,
            __btn_id2: `user-h5`,
            __btn_type: 'common',
        });
        location.href = `/${locale}/my-overview`;
        return;
    };
    return (
        <div className="ef-header-v2__h5-bottom-tabs">
            {!HideUserLocaleList.includes(locale) && (
                <div className="ef-header-v2__h5-bottom-tabs-item GtmModuleData-btn-common ef-header-user-h5" data-btn-id="user-h5" onClick={enterUserHandle}>
                    <HeaderIconUser />
                    <span>{isLogin ? t.my_account : t.login_register}</span>
                </div>
            )}
            <EcoLink
                className="ef-header-v2__h5-bottom-tabs-item GtmModuleData-btn-href glo-nav-locale-href-h5"
                aria-label="locale link"
                href={`/${locale}/region`}
                dataLayer={{
                    __btn_id1: 'glo-nav-locale-href-h5',
                    __btn_id2: `${locale}/region`,
                    __btn_type: 'href',
                }}
            >
                <LocaleIcon />
                <span>{t?.locale_title}</span>
            </EcoLink>
        </div>
    );
};
export default H5BottomTabs;
